import useLocalStorage from "./useLocalStorage";

export default useLocalStorage;